import { useApi } from "@backstage/core-plugin-api";
import { useEffect, useCallback } from "react";
import { useAsyncFn } from "react-use";
import { opsgenieApiRef } from "../api";

export const useOpsgenieUsers = () => {
  const api = useApi(opsgenieApiRef);
  const getUsers = useCallback(async () => await api.getUsers(), [api]);
  const [state, fetchUsers] = useAsyncFn(async () => await getUsers(), []);
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);
  return {
    loading: state.loading,
    error: state.error,
    results: state?.value,
    refetch: fetchUsers,
  };
};
